import { useEffect } from 'react';

declare global {
  interface Window {
    zE?: (...args: unknown[]) => void;
  }
}

const ZENDESK_SCRIPT_ID = 'ze-snippet';
// Chave do Web Widget (Messaging) do Zendesk, definida por ambiente.
// Sem chave o chat não é carregado.
const ZENDESK_KEY = import.meta.env.VITE_ZENDESK_KEY?.trim();

let isWidgetActive = false;

/**
 * Carrega o chat do Zendesk enquanto o componente estiver montado.
 * Usado no layout autenticado: o chat aparece em todas as telas logadas e é
 * escondido ao sair delas (ex.: logout), já que o script não é descarregável.
 */
export function useZendeskWidget() {
  useEffect(() => {
    if (!ZENDESK_KEY) return;

    isWidgetActive = true;

    if (document.getElementById(ZENDESK_SCRIPT_ID)) {
      window.zE?.('messenger', 'show');
    } else {
      const script = document.createElement('script');
      script.id = ZENDESK_SCRIPT_ID;
      script.async = true;
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
      // Logout antes do script terminar de carregar: esconde assim que chegar.
      script.onload = () => {
        if (!isWidgetActive) window.zE?.('messenger', 'hide');
      };
      document.body.appendChild(script);
    }

    return () => {
      isWidgetActive = false;
      window.zE?.('messenger', 'close');
      window.zE?.('messenger', 'hide');
    };
  }, []);
}
